<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon icon="bookmark-check-fill" class="mLeft"></b-icon>
            <div class="headerTxt mLeft">Cambio de especialista individual</div>
          </div>
          <div class="alignIcon bold">CB_01_Tx_Ex</div>
        </div>

        <div class="noAlTope" v-if="cargando">
          <b-button variant="primary" disabled>
            <b-spinner small></b-spinner>
            Cargando...
          </b-button>
        </div>

        <div class="noAlTope" v-else>
          <b-form v-on:submit.prevent="buscarTratamientos">
            <b-row>
              <b-col class="text-left">
                <label>Id del paciente: *</label>
                <b-form-input
                    v-model.trim="idPaciente"
                    :state="idPaciente != null"
                    pattern="[0-9]{1,}"
                    maxLength="15"
                    placeholder="Id del paciente:"
                    required
                >
                </b-form-input>
                <b-form-invalid-feedback :state="idPaciente != null">
                  Coloca el id del paciente
                </b-form-invalid-feedback>
              </b-col>

              <b-col>
                <b-button class="mt-4" type="submit" variant="outline-primary">
                  Buscar
                </b-button>
              </b-col>
            </b-row>
          </b-form>

          <div v-if="encontrado">
            <b-button
                class="mt-4"
                v-if="cargandoLista"
                variant="primary"
                disabled
            >
              <b-spinner small></b-spinner>
              Cargando...
            </b-button>

            <div v-else>
              <div class="mt-4">
                <b-alert show variant="primary">
                  <label>Nombre del paciente: </label>
                  {{ nombrePaciente }}
                </b-alert>
              </div>

              <b-row class="mt-4 text-left">
                <b-col>
                  <label>Búsqueda de tratamiento:</label>
                  <b-form-input
                      v-model="trtBusqueda"
                      type="search"
                      placeholder="Nombre del tratamiento"
                  >
                  </b-form-input>
                </b-col>
                <b-col>
                  <label>Asignar doctor:</label>
                  <v-select
                      v-model="idEmpleado"
                      :options="listaDoctores"
                      label="nombreDoctor"
                      @input="deseleccionarTratamientos($event)"
                  >
                  </v-select>
                </b-col>
              </b-row>

              <b-table
                  class="mt-4"
                  thead-tr-class="columnas"
                  :items="listaTrt"
                  :fields="tituloTrt"
                  :per-page="porPagina"
                  :current-page="paginaActual"
                  :filter="trtBusqueda"
              >
                <template v-slot:cell(nombreAbre)="row">
                  <span v-b-popover.hover.top="row.item.doctor">
                    {{ row.item.nombreAbre }}
                  </span>
                </template>
                <template v-slot:cell(fecha)="row">
                  {{ row.item.fecha | formatoFecha }}
                </template>
                <template v-slot:cell(numeroSesion)="row">
                  <span>
                    {{ row.item.numeroSesion + "/" + row.item.maximoSesion }}
                  </span>
                </template>
                <template v-slot:cell(nuevoAbre)="row">
                  <span v-b-popover.hover.top="row.item.nuevoDoctor">
                    {{ row.item.nuevoAbre }}
                  </span>
                </template>
                <template v-slot:cell(asignar)="row">
                  <b-form-checkbox
                      v-model="row.item.seleccionado"
                      v-on:change="traerAbreviadoNombre(row.item)"
                  >
                  </b-form-checkbox>
                </template>
              </b-table>
              <b-row>
                <b-col>
                  <b-pagination
                      v-model="paginaActual"
                      :total-rows="listaTrt.length"
                      :per-page="porPagina"
                      align="center"
                  ></b-pagination>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-button
                      class="mt-4"
                      variant="primary"
                      v-show="enviando"
                      disabled
                  >
                    <b-spinner small></b-spinner>
                    Cargando...
                  </b-button>
                  <b-button
                      class="mt-4"
                      variant="outline-primary"
                      v-on:click="guardarDoctores"
                      v-if="!enviando"
                  >
                    Guardar
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import VueNotifications from "vue-notifications";

export default {
  name: "CambioEspecialista",
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    idPaciente: null,
    nombrePaciente: null,
    listaDoctores: [],
    idEmpleado: null,
    porPagina: 15,
    paginaActual: 1,
    trtBusqueda: null,
    listaTrt: [],
    tituloTrt: [
      {
        key: "diente",
        label: "OD",
        sortable: true,
      },
      {
        key: "fecha",
        label: "Fecha",
        sortable: true,
      },
      {
        key: "tratamiento",
        label: "Tratamiento",
        sortable: true,
      },
      {
        key: "numeroSesion",
        label: "Número de sesión",
      },
      {
        key: "origen",
        label: "Origen",
      },
      {
        key: "nombreAbre",
        label: "Doctor Actual",
        sortable: true,
      },
      {
        key: "nuevoAbre",
        label: "Doctor nuevo",
        sortable: true,
      },
      {
        key: "asignar",
        label: "Asignar",
      },
    ],
    cargando: true,
    encontrado: false,
    cargandoLista: false,
    enviando: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.buscarDoctores();
  },
  methods: {
    buscarDoctores() {
      const url =
          this.$api +
          "colaboradores/obtener/nombres";
      this.$http
          .post(url, this.$localStorageService.getIdClinica())
          .then((response) => {
            this.listaDoctores = response.data.data;

            //agregamos titulo al metodo de pago
            let tituloPago = {
              idEmpleado: null,
              nombreDoctor: "Especialista: ",
            };
            this.listaDoctores.unshift(tituloPago);
          })
          .finally(() => {
            this.cargando = false;
          });
    },
    buscarTratamientos() {
      this.idEmpleado = null;
      this.encontrado = true;
      this.cargandoLista = true;
      const url =
          this.$api +
          "paciente/tratamientos/programados";

      this.$http
          .post(url, this.idPaciente)
          .then((response) => {
            this.nombrePaciente = response.data.data.nombrePaciente;

            let cont = 0;
            response.data.data.trtProgramados.map(e => {
                  e.idEmpleado = null
                  e.idClinica = null
                  e.seleccionado = false
                  e.nuevoAbre = ""
                  e.nuevoDoctor = ""
                  e.posicion = cont++
                });

            this.listaTrt = response.data.data.trtProgramados;
            this.listaTrtOrignal = response.data.data.trtProgramados;
          })
          .catch((err) => {
            this.errorTraer(err);
            this.encontrado = false;
          })
          .finally(() => {
            this.cargandoLista = false;
          });
    },
    traerAbreviadoNombre(item) {
      if (this.idEmpleado != null) {
        let abre = "";
        this.listaDoctores.forEach((i) => {
          if (i.idEmpleado === this.idEmpleado.idEmpleado) {
            abre = i.nombreDoctor;
          }
        });

        const matches = abre.match(/\b(\w)/g);



        item.idEmpleado = this.idEmpleado.idEmpleado;
        item.nuevoAbre = matches.join("");
        item.nuevoDoctor = abre;
      } else {
        item.idEmpleado = null;
        item.nuevoDoctor = null;
        item.nuevoAbre = null;
      }
    },
    deseleccionarTratamientos(txs) {
      this.listaTrt.forEach((i) => {
        i.seleccionado = false;
      });
      if (txs != null) {
        this.listaTrt = this.listaTrtOrignal.filter(item => {
          return txs.tratamientos.includes(item.idTratamiento)
        })
      } else {
        this.listaTrt = this.listaTrtOrignal;
      }
    },
    guardarDoctores() {
      this.enviando = true;
      const url = this.$api + "paciente/tratamientos/programados";
      this.$http
          .put(url, this.traerDatos())
          .then((response) => {
            if (response.status === 200) {
              this.$swal({
                icon: "success",
                text: "Se envio la información correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
              setTimeout(() => location.reload(), 2000);
              this.enviando = false;
            }
          })
          .catch((err) => {
            this.enviando = false;
            this.errorEnviar(err);
          });
    },
    traerDatos() {
      let listaNueva = [];
      this.listaTrt.forEach((i) => {
        if (i.idEmpleado != null) {
          let datos = {
            idTratamientoProgramado: i.idTratamientoProgramado,
            idEmpleado: i.idEmpleado,
            idClinica: this.$localStorageService.getIdClinica(),
            usuarioLogeado: this.$localStorageService.getIdUsuario(),
          };
          listaNueva.push(datos);
        }
      });

      return listaNueva;
    },
  },
  notifications: {
    errorTraer: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnviar: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>

<style>
</style>
